import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import AuthProvider from "../provider/AuthProvider";
import ActionsProvider from "../provider/ActionsProvider";
import LayoutProvider from "../provider/LayoutProvider";

import ScrollToTop from "../components/ScrollTop";

import DesktopLayout from "../components/Layout/DesktopLayout";
import MobileLayout from "../components/Layout/MobileLayout";
import AuthLayout from "../components/Layout/Auth";

import useIsMobile from "../hooks/deviceChecker";

import SignIn from "./SignIn";
import NotFound from "../pages/NotFound";

import Community from "./Dashboard/Community";
import MyCourses from "./Dashboard/MyCourses";
import Courses from "./Dashboard/Courses";
import Profile from "./Dashboard/Profile";

const Component = () => {
  const isMobile = useIsMobile();

  return (
    <>
      <ScrollToTop useLocation={useLocation} />
      <Routes>
        <Route
          path="dashboard"
          element={
            <AuthProvider>
              <ActionsProvider useLocation={useLocation}>
                <LayoutProvider useLocation={useLocation}>
                  {isMobile ? <MobileLayout /> : <DesktopLayout />}
                </LayoutProvider>
              </ActionsProvider>
            </AuthProvider>
          }
        >
          <Route index element={<Navigate to={"cursos/list"} />} />
          <Route path="mi-perfil" element={<Profile />} />
          <Route path="comunidad" element={<Community.Preview />} />
          <Route path="mis-cursos">
            <Route index element={<Navigate to="list" />} />
            <Route path="list" element={<MyCourses.List />} />
            <Route path=":idCourse">
              <Route index element={<Navigate to="finished" />} />
              <Route path="finished" element={<MyCourses.Finished />} />
              <Route path="valoration" element={<MyCourses.Valoration />} />
              <Route
                path="*"
                element={<Navigate to={"/dashboard/mis-cursos"} />}
              />
            </Route>
            <Route
              path=":idCourse/:idUnit/:idComponent"
              element={<MyCourses.Preview />}
            />
            <Route
              path="*"
              element={<Navigate to={"/dashboard/mis-cursos"} />}
            />
          </Route>
          <Route path="cursos">
            <Route index element={<Navigate to="list" />} />
            <Route path="list" element={<Courses.List />} />
            <Route path=":idCourse" element={<Courses.Preview />} />
            <Route
              path="*"
              element={<Navigate to={"/dashboard/cursos"} />}
            />
          </Route>

          <Route
            path="*"
            element={<Navigate to={"/dashboard/mis-cursos/list"} />}
          />
        </Route>
        <Route path="auth" element={<AuthLayout />}>
          <Route index element={<Navigate to="sign-in" />} />
          <Route path="sign-in" element={<SignIn />} />
          <Route
            path="*"
            element={<Navigate to={"/"} />}
          />
        </Route>
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </>
  );
};

export default Component;
